import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentLoadOverview } from '../../models';
import { ShipmentLoadMainInfoFacade } from '../main-info/shipment-load-main-info.facade';
import { TransportMode } from '../../../../../common/constants';
import { setInitialStoreState } from '../../../../../common/utils';
import { ShipmentLoadTransportOrdersFacade } from './shipment-load-transport-orders.facade';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadTransportOrdersGuard {
  constructor(
    private shipmentLoadTransportOrdersFacade: ShipmentLoadTransportOrdersFacade,
    private shipmentLoadMainInfoFacade: ShipmentLoadMainInfoFacade,
  ) {}

  canActivate({ queryParams }: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    const { loadNumber } = queryParams;
    return this.shipmentLoadMainInfoFacade.mainInfo$.pipe(
      filter(Boolean),
      map((mainInfo: ShipmentLoadOverview) => {
        if (mainInfo.transportMode !== TransportMode.Air) {
          this.shipmentLoadTransportOrdersFacade.loadAll({ loadNumber });
        }
        return true;
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentLoadTransportOrdersFacade);
  }
}
